import React from 'react'
import { CheckCircleOutline, ErrorOutline, TrendingUp } from '@material-ui/icons'

import { Link } from 'react-router-dom'

import './Index.css'

const Index = ({ user }) => {
    const counter = user?.workPlace

    return (
        <div className="index">
             <h2 className="mb-40 py-20 font-subhead">Oluwatosin Ojo</h2>
             <div className="index__cards">
                <div className="index__projects py-20 px-40">
                    <p className="font-big font-bold">Projects</p>
                    <div className="d-flex flex-wrap">
                        <Link to="/projects/inactive" className="index__card d-flex flex-column box-shadow-lg p-20 my-20 mr-20 rounded">
                            <div className="d-flex align-center">
                                <ErrorOutline className="icon-orange" fontSize="small" />
                                <span className="pl-10 font-bold font-sm">Inactive Projects</span>
                            </div>
                            <span style={{background: 'rgb(255, 205, 220)', color: 'red'}} className="font-bolder ml-auto text-right px-20 mt-5 curved-20">{!counter ? 0 : counter.inactive_projects ? counter.inactive_projects.length : 0}</span>
                        </Link>
                        <Link to="/projects/ongoing" className="index__card d-flex flex-column box-shadow-lg p-20 my-20 mr-20 rounded">
                            <div className="d-flex align-center">
                                <TrendingUp className="icon-orange" fontSize="small" />
                                <span className="pl-10 font-bold font-sm">Ongoing Projects</span>
                            </div>
                            <span style={{background: 'rgb(255, 236, 200)', color: 'orange'}} className="font-bolder ml-auto text-right px-20 mt-5 curved-20">{!counter ? 0 : counter.ongoing_projects ? counter.ongoing_projects.length : 0}</span>
                        </Link>
                        <Link to="/projects/completed" className="index__card d-flex flex-column box-shadow-lg p-20 my-20 mr-20 rounded">
                            <div className="d-flex align-center">
                                <CheckCircleOutline className="icon-orange" fontSize="small" />
                                <span className="pl-10 font-bold font-sm">Completed Projects</span>
                            </div>
                            <span style={{background: 'rgb(223, 255, 223)', color: 'green'}} className="font-bolder ml-auto text-right px-20 mt-5 curved-20">{!user.completedProjects ? 0 : user.completedProjects}</span>
                        </Link>
                        <Link to="/quote" className="">
                            <button 
                              style={{ color: '#fff', backgroundColor: '#ff5e15' }}
                              className="index__card d-flex align-center justify-center box-shadow-lg p-20 my-20 mr-20 rounded outline-0 border-0 font-big font-bolder">
                                Get a Quote
                            </button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Index
